import {
  RateCardSupplierProduct as Channel,
  RateCardLocation,
} from "models/ratecard"

import groupBy from "lodash/fp/groupBy"

export const DAYS_OF_WEEK = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"]

export const DEFAULT_ID = "DEFAULT"

export const DEFAULT_CHANNEL: Channel = {
  id: DEFAULT_ID,
  name: "rateCard.channel.default.name",
}

export const BREAKDOWN_SEMANTIC_CODE = "duration"

export const getChannels = (list: (Channel | null)[]): Channel[] => {
  return list.map((x) => (x === null ? DEFAULT_CHANNEL : x))
}

export const getLocationsPerChannel = (ls: RateCardLocation[]) => {
  const locations: RateCardLocation[] = ls.map((l) => ({
    location: l.location,
    supplierProductId: l.supplierProductId ?? DEFAULT_ID,
  }))
  return groupBy((x) => x.supplierProductId, locations)
}

export const NON_FILTERABLE = ["description", "duration", "id"]
export const MULTIPLE_FILTERING = ["daysOfWeek", "targetB"]
export const SINGLE_FILTERING = ["segment", "category"]
